
<v-chip
  small
  class="export-frequency-chip"
  :class="`export-frequency-chip--${normalizedFrequency}`"
  :aria-label="`Export frequency: ${frequency}`"
>
  <v-icon
    left
    x-small
  >
    {{ icon }}
  </v-icon>
  {{ displayText }}
</v-chip>
